module.exports = __webpack_public_path__ + "app/principal/companies-details-29VeN2fj.html";